import { removeNewLines, formatUnitString } from './formatString';

const getUnitInfoObj = (value, unit) => ({ value, unit });

const getSecondsInfo = (value) => {
  if (value < 60) return getUnitInfoObj(value, 'сек.');
  return getUnitInfoObj(Math.floor(value / 60), 'мин.');
};

const getKbytesInfo = (value) => {
  if (value < 1048576) {
    const numInMb = value / 1024;
    return getUnitInfoObj(Number(numInMb.toFixed(2)), 'МБ');
  }

  const numInGb = (value / 1048576 * 10) / 10;
  return getUnitInfoObj(Number(numInGb.toFixed(2)), 'ГБ');
};

export const accumulatorTypes = {
  kbyte: 'KBYTE',
  seconds: 'SECONDS',
  mms: 'MMS',
  sms: 'SMS',
  rur: 'RUR',
};

export function printSeconds(value) {
  const info = getSecondsInfo(value);
  return `${info.value} ${info.unit}`;
}

export function printKbytes(value) {
  const info = getKbytesInfo(value);
  return `${info.value} ${info.unit}`;
}

export function printBytes(value) {
  return value < (1073741824)
    ? `${Math.floor(value / 1048576 * 10) / 10} МБ`
    : `${Math.floor(value / 1073741824 * 10) / 10} ГБ`;
}

export function getProgressBarColor(accumulator, progressBarLimits) {
  const percent = accumulator.rest / accumulator.size * 100;

  return Object.keys(progressBarLimits).find((color) => {
    const { min, max } = progressBarLimits[color];
    if (percent <= max && percent >= min) return true;
    return false;
  });
}

export const getAccumulatorInfo = (accumulator) => {
  switch (accumulator.unit) {
    case accumulatorTypes.kbyte:
      return getKbytesInfo(accumulator.rest);
    case accumulatorTypes.seconds:
      return getSecondsInfo(accumulator.rest);
    case accumulatorTypes.mms:
    case accumulatorTypes.sms:
      return getUnitInfoObj(accumulator.rest, 'шт.');
    case accumulatorTypes.rur:
      return getUnitInfoObj(accumulator.rest, '₽');
    default:
      return getUnitInfoObj(accumulator.rest, accumulator.unit);
  }
};

export default function printAccumulator(accumulator) {
  const isShowSize = accumulator.size >= accumulator.rest;
  switch (accumulator.unit) {
    case 'KBYTE':
      return removeNewLines(`
        ${formatUnitString(accumulator.rest, 'KBYTE')}
        ${isShowSize ? `из ${formatUnitString(accumulator.size, 'KBYTE')}` : ''}
      `);
    case 'SECONDS':
      return removeNewLines(`
        ${printSeconds(accumulator.rest)}
        ${isShowSize ? `из ${printSeconds(accumulator.size)}` : ''}
      `);
    case 'SMS':
      return removeNewLines(`
        ${accumulator.rest}
        ${isShowSize ? `из ${accumulator.size}` : ''}
        шт.
      `);
    case 'MMS':
      return removeNewLines(`
        ${accumulator.rest}
        ${isShowSize ? `из ${accumulator.size}` : ''}
        шт.
      `);
    case 'RUR':
      return removeNewLines(`
        ${accumulator.rest}
        ${isShowSize ? `из ${accumulator.size}` : ''}
        ₽
      `);
    default:
      return removeNewLines(`
        ${accumulator.rest}
        ${isShowSize ? `из ${accumulator.size}` : ''}
        ${accumulator.unit}
      `);
  }
}

export const createEmptyAccumulator = ({ unit }) => ({
  unit,
  rest: 0,
  size: 0,
  nextValue: 0,
  isUnlimited: false,
});

export const chekIsSpentAcc = ({ rest }) => rest === 0;
